import { ExploreInsightDirection, InsightDirection } from '@toggle/toggle';

export const getExploreDirection = (
  direction: InsightDirection
): ExploreInsightDirection => {
  switch (direction) {
    case InsightDirection.Unspecified:
      return ExploreInsightDirection.Bullish;
    case InsightDirection.Bullish:
      return ExploreInsightDirection.Bullish;
    default:
      return ExploreInsightDirection.Bearish;
  }
};
